// extracted by mini-css-extract-plugin
module.exports = {"main-container":"parameters__main-container___n8FbF","mainContainer":"parameters__main-container___n8FbF"};